import { render, staticRenderFns } from "./ColumnChart.vue?vue&type=template&id=1f89ddb6&scoped=true&"
import script from "./ColumnChart.vue?vue&type=script&lang=js&"
export * from "./ColumnChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f89ddb6",
  null
  
)

export default component.exports